"use client";

import React from "react";
import { AppRouterCacheProvider as MuiAppRouterCacheProvider } from "@bpipartners/webui";

export function AppRouterCacheWrapper({ children }: { children: React.ReactNode }) {
  return <MuiAppRouterCacheProvider options={{ key: "css" }}>{children}</MuiAppRouterCacheProvider>;
}
